function prepare_data(data) {
    $.ajax({
        type: "GET",
        url: '/location-map/devices/',
    }).done(function(response) {
        initMap(response.data);
        initOSM(response.data);
    }).fail(function(response) {
        console.log(response)
    });
}


function initMap(devices) {
    let mapElement = document.getElementById("map");

    if (mapElement === null) {
        return
    }

    map = new google.maps.Map(mapElement, {
      zoom: Number(mapElement.dataset.zoom),
      center: { lat: Number(devices[0].coords.lat), lng: Number(devices[0].coords.lng) }
    });

    for (let i=0; i<devices.length; i++) {
        var marker = new google.maps.Marker({
            map: map,
            position: devices[i].coords,
            label: {
                text: devices[i].device,  //devices[i].orders.toString(),
                fontSize: "8px"
              }
        });
        addInfoWindow(marker, devices[i])
    }
  }

  function addInfoWindow(marker, device) {
    let message = consructMessage(device)
    var infoWindow = new google.maps.InfoWindow({
        content: message
    });

    google.maps.event.addListener(marker, 'click', function () {
        infoWindow.open(map, marker);
    });

    // close infowindow by click on the map
    map.addListener('click', function() {
        if (infoWindow) infoWindow.close();
    });
}

function consructMessage(device){
    return "<p>" + gettext('Device') + ": " + device.device + "</p>" +
           "<p>" + gettext('Address') + ": " + device.address + "</p>";
}

function initOSM(devices) {
    let mapElement = document.getElementById("mapid");

    if (mapElement === null) {
        return
    }

    var mymap = L.map('mapid').setView(
        [Number(devices[0].coords.lat), Number(devices[0].coords.lng)],
        Number(mapElement.dataset.zoom)
    );
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(mymap);

    for (let i=0; i<devices.length; i++) {
        var marker = L.marker(
            [devices[i].coords.lat, devices[i].coords.lng],
            {
                title: devices[i].device,
                alt: devices[i].device
            }
        ).addTo(mymap);
        marker.bindTooltip(devices[i].device)
        marker.bindPopup(consructMessage(devices[i]))
    }
}
